//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState,
  mapMutations
} from 'vuex'
import {
  orderList,
  userInfo,
  changePassword
} from '@/service/index'

import Order from '@/components/order/Order.vue'

export default {
  data() {
    return {
      userInfo: {},
      loginForm: {
        oldPassword: "",
        newPassword: ""
      },
      formRules: {
        oldPassword: [{
          required: true,
          message: this.$t('login.passwordTip'),
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: this.$t('login.passwordTip'),
          trigger: 'blur'
        }]
      },
      modifyLoading:false,
      dialogModifyPassVisible: false,
      orderList: [],
      isLoading: true,
      profileHead: require('../../assets/default-avatar.png'),
      profileHeadMb: require('../../assets/default-avatar.png'),
      editImg: require('../../assets/edit.png'),
      editImgbw: require('../../assets/edit_bw.png')
    }
  },
  components: {
    Order
  },
  mounted() {
    this.getOrderList()
    this.getUserInfo()
    this.keepLang()
  },
  computed: {
    ...mapState(['global', 'campaign']),
    getNoPaiedOrder() {
      return this.orderList.filter(order => order.status === 1)
    },
    getPaiedOrder() {
      return this.orderList.filter(order => order.status === 2)
    }
  },
  methods: {
    onModifyPass() {
      if(this.modifyLoading) return false
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.doModifyPwd()
        }
      })
    },
    async doModifyPwd() {
      const param = Object.assign({}, this.loginForm)
      this.modifyLoading=true
      const res = await changePassword(param);
      this.modifyLoading=false
      if (res.status === 0) {
        this.$message({
          message: this.$t('login.modifySuccess'),
          type: 'success'
        })
        this.$router.push({
          path: '/login',
          query: {
            cid: this.$route.query.cid
          }
        })
      } else {
        this.$message({
          message: "User Password Error!",
          type: 'error'
        })
      }
    },
    async getOrderList() {
      const res = await orderList(this.$route.query.cid)
      this.isLoading = false
      if (res.status === 0) {
        this.orderList = res.data
      }
    },
    async getUserInfo() {
      const res = await userInfo(this.$route.query.cid)
      if (res.status === 0) {
        this.userInfo = res.data
      }
    },
    cancel(order) {
      order.status = 12
    },
    keepLang() {
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },
  }
}




// WEBPACK FOOTER //
// ./src/pages/my/Order.vue